import React from 'react'

export default function ProductImage({ imageSource, color }) {
  return <img src={imageSource} style={{ height: '60px', backgroundColor: color }} alt="Product" className="p-2 rounded-3 " />
}
